export function Chips({ chips, onChip }: { chips: string[]; onChip: (text: string) => void }) {
  if (!chips.length) return null;
  return (
    <div className="tp-chips">
      {chips.map((c, i) => (
        <button key={i} className="chip" onClick={() => onChip(c)}>
          {c}
        </button>
      ))}
    </div>
  );
}
